export const defaultGroups = {
    [0 /* GroupIndex.Foyer */]: [
        2 /* SlideIndex.LogoOnlyStart */,
        7 /* SlideIndex.GospelMeeting */,
        6 /* SlideIndex.GuestSpeakers */,
        12 /* SlideIndex.WorshipTimes */,
        11 /* SlideIndex.Website */,
        9 /* SlideIndex.Informer */,
        10 /* SlideIndex.Members */,
    ], // , 'map'
    [1 /* GroupIndex.Auditorium */]: [
        2 /* SlideIndex.LogoOnlyStart */,
        7 /* SlideIndex.GospelMeeting */,
        6 /* SlideIndex.GuestSpeakers */,
        12 /* SlideIndex.WorshipTimes */,
        11 /* SlideIndex.Website */,
        9 /* SlideIndex.Informer */,
    ],
};
